import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import theme from './assets/theme'
import { HashRouter, Routes, Route } from 'react-router-dom';


// routes
import { ProtectedRoute, Login, Error, Dashboard, Clients, Users, Booking, MultiBooking, Checkout, CheckoutDetail, Product, CashOpen,
         CashClose, DailySummary, Level, Category, Room, MonthlyReport, DailyReport, DailyReportUser,
         DailyReportCash, SellProduct, CreateMultiBooking, SellProductDetail } from './routes/index';

// redux
import { Provider } from 'react-redux';
import store from './redux/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={ store }>
    <ThemeProvider theme={theme}>
      <HashRouter>
          <Routes>
              <Route path='/' >
                <Route index element={ <Login /> } />
                <Route element={ <ProtectedRoute /> }>
                  <Route path='/dashboard' element={ <Dashboard /> } />
                  <Route path='/clients' element={ <Clients /> } />
                  <Route path='/users' element={ <Users /> } />
                  <Route path='/bookings' element={ <Booking /> } />
                  <Route path='/multibooking' element={ <MultiBooking /> } />
                  <Route path='/createmultibooking' element={ <CreateMultiBooking /> } />
                  <Route path='/checkouts' element={ <Checkout /> } />
                  <Route path='/checkoutdetail/:room' element={ <CheckoutDetail /> } />
                  <Route path='/products' element={ <Product /> } />
                  <Route path='/sellproduct' element={ <SellProduct /> } />
                  <Route path='/sellproduct/:room' element={ <SellProductDetail /> } />
                  <Route path='/cashopen' element={ <CashOpen /> } />
                  <Route path='/cashclose' element={ <CashClose /> } />
                  <Route path='/dailysummary' element={ <DailySummary /> } />
                  <Route path='/levels' element={ <Level /> } />
                  <Route path='/rooms' element={ <Room /> } />
                  <Route path='/categories' element={ <Category /> } />
                  <Route path='/monthlyreport' element={ <MonthlyReport /> } />
                  <Route path='/dailyreport' element={ <DailyReport /> } />
                  <Route path='/dailyreportuser' element={ <DailyReportUser /> } />
                  <Route path='/dailyreportcash' element={ <DailyReportCash /> } />
                </Route>
                <Route path='/*' element={ <Error /> } />
              </Route>
          </Routes>
      </HashRouter>
    </ThemeProvider>
  </Provider>
);